import {Part} from "../part";
import {wallsThumbnail} from "../../../bvComponent/core/assets";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import store from "../../../../store";
import LeftWall from "../subparts/walls/leftWall";
import RightWall from "../subparts/walls/rightWall";
import CenterWall from "../subparts/walls/centerWall";
import BackWall from "../subparts/walls/backWall";
import Ceiling from "../subparts/walls/ceiling";
import FrontWall from "../subparts/walls/frontWall";
import SplitWall from "../subparts/walls/splitWall";
import LeftWallSplitter from "../subparts/walls/leftWallSplitter";
import CeilingPanels from "../subparts/walls/ceilingPanels";

export default class Walls extends Part {
  static id = 'Walls';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Walls';
    this.translateId = "visualizer.bathroom.walls";
    this.partThumbnail = wallsThumbnail;

    // related items
    this.leftWall = null;
    this.rightWall = null;
    this.centerWall = null;
    this.frontWall = null;
    this.popoutWall = null;
    this.backWall = null;
    this.ceiling = null;
    this.ceilingPanels = null;
    this.splitWall = null;
    this.leftWallSplitter = null;

    this.allWallsApplied = true;
    this.relatedGroupNames = ["Backsplash", "Left Wall Splitter", "Left Wall", "Right Wall", "Center Wall",
      "Front Wall", "Back Wall", "Ceiling", "Ceiling Panels"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Left Wall":
      case "Left Wall Crop":
        relatedItemName = "leftWall";
        RelatedItemClass = LeftWall;
        break;
      case "Right Wall":
      case "Right Wall Crop":
        relatedItemName = "rightWall";
        RelatedItemClass = RightWall;
        break;
      case "Center Wall":
        relatedItemName = "centerWall";
        RelatedItemClass = CenterWall;
        break;
      case "Front Wall":
      case "Front Wall Crop":
        relatedItemName = "frontWall";
        RelatedItemClass = FrontWall;
        break;
      case "Back Wall":
      case "Beack Wall":
        relatedItemName = "backWall";
        RelatedItemClass = BackWall;
        break;
      case "Split Wall":
        relatedItemName = "splitWall";
        RelatedItemClass = SplitWall;
        break;
      case "Left Wall Splitter":
        relatedItemName = "leftWallSplitter";
        RelatedItemClass = LeftWallSplitter;
        break;
      case "Ceiling Panels":
        relatedItemName = "ceilingPanels";
        RelatedItemClass = CeilingPanels;
        break;
      case "Ceiling":
      case "Cealing":
        relatedItemName = "ceiling";
        RelatedItemClass = Ceiling;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts(withHidden = true) {
    return this.relatedItems
      .filter(item => {
        return this.filterRelatedItem(item, withHidden)
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  recoverPrevioslySelected(activeRelatedPart) {
    const {activeQuoteIndex} = store.getState().quotesState;
    this.relatedItems.forEach(relatedItem => {
      if (relatedItem.partId !== activeRelatedPart.partId && relatedItem.activeFeatureBeforeAllWalls) {
        if (relatedItem.activeFeatureBeforeAllWalls === "placeholder") {
          relatedItem.placeholderChanged = false;
          relatedItem.firstClick[activeQuoteIndex] = false;
        } else if (!relatedItem.selectedByUser) {
          relatedItem.activeFeatureBeforeAllWalls.clickFromAllWalls();
        }
      }
    });
  }

  getSplitWallType() {
    if (!this.splitWall) {
      return null
    }
    if (!this.splitWall.disabled && this.splitWall.activeFeature && this.splitWall.activeFeature.metaData["SplitWallType"]
      && this.splitWall.activeFeature.matchesMetaForArrayOfConditions(this.splitWall.getArrayOfConditions())) {
      return this.splitWall.activeFeature.metaData["SplitWallType"]
    } else {
      return ["NW", "0"]
    }
  }

}
